import axiosInstance from ".";

export const getContact = () => {
  return axiosInstance.get("/contact");
};

export const addContact = (data) => {
  return axiosInstance.post("/contact", data);
};

export const updateContact = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/contact/${id}`, payload);
};

export const getQueries = () => {
  return axiosInstance.get("/contact-query");
};